import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store";
import Theme from "components/template/Theme";
import Layout from "components/layout";
import history from "./history";
import "./locales";
import { ScrollBar } from "components/ui";
import "./app.css";
import { PdfViewerProvider } from "contexts/PdfViewerContext";
import SessionManager from "contexts/SessionManager";
import MaintenanceController from "contexts/MaintenanceController";
import { Loading } from "components/shared";
//
function App() {
  return (
    <ScrollBar
      autoHide={true}
      autoHideTimeout={1000}
      autoHideDuration={400}
      style={{ width: "100vw", height: "100vh" }}
    >
      <Provider store={store}>
        <PersistGate loading={<Loading />} persistor={persistor}>
          <BrowserRouter history={history}>
            <Theme>
              <PdfViewerProvider>
                {/* This runs the shared timeout & multi-tab sync */}
                <SessionManager />
                <MaintenanceController />
                <Layout />
              </PdfViewerProvider>
            </Theme>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ScrollBar>
  );
}

export default App;
